module.exports = __webpack_public_path__ + "img/top.85765146.jpg";